import { Flex, Form, InputNumber, theme } from 'antd';
import { useTranslation } from 'translations/hooks';

import { requiredRule } from 'technical/validation/rules';

import type { FormInstance } from 'antd';

export type PreloadFormValues = {
  startRing: number;
  endRing: number;
};

export const PreloadForm = ({
  form,
  onFinish,
  isRangeDefined,
  isOrderValid,
  isInRange,
}: {
  form: FormInstance<PreloadFormValues>;
  onFinish: (values: PreloadFormValues) => void;
  isRangeDefined: boolean;
  isOrderValid: boolean;
  isInRange: boolean;
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  const orderError = !isOrderValid
    ? t('qualityControl.recordSegmentDefect.rightPanel.errors.startRingTooHigh')
    : null;
  const rangeError = !isInRange
    ? t('qualityControl.recordSegmentDefect.rightPanel.errors.rangeExceeded')
    : null;
  const sharedError = orderError ?? rangeError;

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Flex gap={16}>
        <Form.Item<PreloadFormValues>
          name="startRing"
          label={t('qualityControl.recordSegmentDefect.rightPanel.startRing')}
          style={{ flex: 1, marginBottom: sharedError ? 4 : undefined }}
          rules={[requiredRule]}
        >
          <InputNumber inputMode="numeric" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item<PreloadFormValues>
          name="endRing"
          label={t('qualityControl.recordSegmentDefect.rightPanel.endRing')}
          style={{ flex: 1, marginBottom: sharedError ? 4 : undefined }}
          rules={[requiredRule]}
        >
          <InputNumber inputMode="numeric" style={{ width: '100%' }} />
        </Form.Item>
      </Flex>
      {isRangeDefined && sharedError ? (
        <div style={{ color: token.colorError, fontSize: token.fontSize }}>
          {sharedError}
        </div>
      ) : null}
    </Form>
  );
};
